export default {"src":"/_next/static/media/haze.d113cf99.svg","height":164,"width":164};